import React, { forwardRef, useState, useCallback, useEffect, useRef, useMemo, Fragment } from 'react';
import { styled, makeStyles, withStyles as withStyles$1 } from '@material-ui/core/styles';
import MuiDivider from '@material-ui/core/Divider';
import MuiTypography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiContainer from '@material-ui/core/Container';
import { Card as Card$1, Typography as Typography$1, Box as Box$1 } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiSnackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import { useWindowSize } from '@memoryfactory/common';
import ChevronRightRounded from '@material-ui/icons/ChevronRightRounded';
import ChevronLeftRounded from '@material-ui/icons/ChevronLeftRounded';
import Skeleton from '@material-ui/lab/Skeleton';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Divider = styled(function (_ref) {
  var spacing = _ref.spacing,
      other = objectWithoutProperties(_ref, ["spacing"]);
  return React.createElement(MuiDivider, other);
})(function (_ref2) {
  var theme = _ref2.theme,
      spacing = _ref2.spacing;
  var styles = {};

  if (spacing) {
    styles = _objectSpread(_objectSpread({}, styles), {}, {
      marginTop: theme.spacing(spacing),
      marginBottom: theme.spacing(spacing)
    });
  }

  return styles;
});

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function toVal(mix) {
  var k,
      y,
      str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }

  return str;
}

function clsx() {
  var i = 0,
      tmp,
      x,
      str = '';

  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }

  return str;
}

var useStyles = makeStyles(function (theme) {
  return {
    pointer: {
      cursor: 'pointer'
    },
    white: {
      color: '#fff'
    },
    raw: {
      whiteSpace: 'break-spaces'
    },
    underline: {
      textDecoration: 'underline'
    },
    bold: {
      fontWeight: theme.typography.fontWeightBold
    },
    semiBold: {
      fontWeight: theme.typography.fontWeightMedium
    }
  };
});
var Typography = forwardRef(function (props, ref) {
  var _clsx;

  var bold = props.bold,
      semiBold = props.semiBold,
      pointer = props.pointer,
      white = props.white,
      raw = props.raw,
      underline = props.underline,
      className = props.className,
      children = props.children,
      rest = objectWithoutProperties(props, ["bold", "semiBold", "pointer", "white", "raw", "underline", "className", "children"]);
  var classes = useStyles();
  var typographyClasses = clsx((_clsx = {}, defineProperty(_clsx, classes.bold, bold), defineProperty(_clsx, classes.semiBold, semiBold), defineProperty(_clsx, classes.pointer, pointer), defineProperty(_clsx, classes.white, white), defineProperty(_clsx, classes.raw, raw), defineProperty(_clsx, classes.underline, underline), _clsx), !!className && defineProperty({}, className, className));
  return React.createElement(MuiTypography, _extends_1({
    className: typographyClasses,
    innerRef: ref
  }, rest), children);
});
Typography.defaultProps = {
  bold: false,
  semiBold: false,
  pointer: false,
  white: false,
  raw: false,
  underline: false
};
var useStyles$1 = makeStyles({
  fullWidth: {
    width: '100%'
  },
  fullFlex: {
    flex: 1
  },
  pointer: {
    cursor: 'pointer'
  }
});
var View = forwardRef(function (props, ref) {
  var _clsx;

  var fullWidth = props.fullWidth,
      fullFlex = props.fullFlex,
      pointer = props.pointer,
      className = props.className,
      children = props.children,
      rest = objectWithoutProperties(props, ["fullWidth", "fullFlex", "pointer", "className", "children"]);
  var classes = useStyles$1();
  var viewClasses = clsx((_clsx = {}, defineProperty(_clsx, classes.fullWidth, fullWidth), defineProperty(_clsx, classes.fullFlex, fullFlex), defineProperty(_clsx, classes.pointer, pointer), _clsx), !!className && defineProperty({}, className, className));
  return React.createElement(Box, _extends_1({
    className: viewClasses
  }, {
    ref: ref
  }, rest), children);
});
View.defaultProps = {
  display: 'flex',
  flexDirection: 'column'
};
var FlexRow = forwardRef(function (props, ref) {
  var children = props.children,
      rest = objectWithoutProperties(props, ["children"]);
  return React.createElement(View, _extends_1({
    ref: ref
  }, rest), children);
});
FlexRow.displayName = 'FlexRow';
FlexRow.defaultProps = {
  flexDirection: 'row',
  alignItems: 'center'
};
var REACT_ELEMENT_TYPE;

function _createRawReactElement(type, props, key, children) {
  if (!REACT_ELEMENT_TYPE) {
    REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
  }

  var defaultProps = type && type.defaultProps;
  var childrenLength = arguments.length - 3;

  if (!props && childrenLength !== 0) {
    props = {
      children: void 0
    };
  }

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = new Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 3];
    }

    props.children = childArray;
  }

  if (props && defaultProps) {
    for (var propName in defaultProps) {
      if (props[propName] === void 0) {
        props[propName] = defaultProps[propName];
      }
    }
  } else if (!props) {
    props = defaultProps || {};
  }

  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: type,
    key: key === undefined ? null : '' + key,
    ref: null,
    props: props,
    _owner: null
  };
}

var jsx = _createRawReactElement;
var useStyles$2 = makeStyles({
  spinner: {
    position: 'absolute',
    height: 100,
    width: 100,
    top: '50%',
    left: 'calc(50% + 40px)',
    marginLeft: -50,
    marginTop: -50,
    zIndex: 200
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 199,
    backgroundColor: 'rgba(0, 0, 0, 0.25)'
  }
});

var AbsoluteCenterSpinner = function AbsoluteCenterSpinner(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? false : _ref$background;
  var classes = useStyles$2();

  if (background) {
    return jsx("div", {
      className: classes.background
    }, void 0, jsx(CircularProgress, {
      className: classes.spinner
    }));
  }

  return jsx(CircularProgress, {
    className: classes.spinner
  });
};

var useStyles$3 = makeStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'stretch',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    center: {
      alignItems: 'center',
      justifyContent: 'center'
    },
    disableHorizontalGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },
    disableVericalGutters: {
      paddingTop: 0,
      paddingBottom: 0
    }
  };
});
var Container = forwardRef(function (props, ref) {
  var _clsx;

  var center = props.center,
      disableHorizontalGutters = props.disableHorizontalGutters,
      disableVericalGutters = props.disableVericalGutters,
      className = props.className,
      children = props.children,
      rest = objectWithoutProperties(props, ["center", "disableHorizontalGutters", "disableVericalGutters", "className", "children"]);
  var classes = useStyles$3();
  var containerClasses = clsx((_clsx = {}, defineProperty(_clsx, classes.container, true), defineProperty(_clsx, classes.center, center), defineProperty(_clsx, classes.disableHorizontalGutters, disableHorizontalGutters), defineProperty(_clsx, classes.disableVericalGutters, disableVericalGutters), _clsx), !!className && defineProperty({}, className, className));
  return React.createElement(MuiContainer, _extends_1({
    className: containerClasses,
    ref: ref
  }, rest), children);
});
Container.defaultProps = {
  center: false,
  disableHorizontalGutters: false,
  disableVericalGutters: false
};
var Card = styled(function (_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["maxWidth", "children"]);
  return React.createElement(Card$1, rest, children);
})(function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  var styles = {};

  if (maxWidth) {
    styles.maxWidth = maxWidth;
  }

  return styles;
});

var Avatar = function Avatar(_ref) {
  var _clsx;

  var classes = _ref.classes,
      children = _ref.children,
      className = _ref.className,
      _ref$plain = _ref.plain,
      plain = _ref$plain === void 0 ? false : _ref$plain,
      _ref$profile = _ref.profile,
      profile = _ref$profile === void 0 ? false : _ref$profile,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large,
      rest = objectWithoutProperties(_ref, ["classes", "children", "className", "plain", "profile", "large"]);
  var cardAvatarClasses = clsx((_clsx = {}, defineProperty(_clsx, classes.cardAvatar, true), defineProperty(_clsx, classes.cardAvatarProfile, profile), defineProperty(_clsx, classes.largeProfile, large), defineProperty(_clsx, classes.cardAvatarPlain, plain), defineProperty(_clsx, className, className !== undefined), _clsx));
  return React.createElement("div", _extends_1({
    className: cardAvatarClasses
  }, rest), children);
};

var CardAvatar = withStyles({
  cardAvatar: {
    '&$cardAvatarProfile img': {
      width: '100%',
      height: 'auto'
    }
  },
  cardAvatarProfile: {
    position: 'relative',
    width: '80px',
    height: '80px',
    margin: '-50px auto 0',
    borderRadius: '50%',
    overflow: 'hidden',
    padding: '0',
    boxShadow: '0 8px 10px -12px rgba(0, 0, 0, 0.56),' + '0 4px 25px 0px rgba(0, 0, 0, 0.12),' + '0 8px 10px -5px rgba(0, 0, 0, 0.2)'
  },
  largeProfile: {
    position: 'relative',
    width: '120px',
    height: '120px',
    margin: '-50px auto 0',
    borderRadius: '50%',
    overflow: 'hidden',
    padding: '0',
    boxShadow: '0 8px 10px -12px rgba(0, 0, 0, 0.56),' + '0 4px 25px 0px rgba(0, 0, 0, 0.12),' + '0 8px 10px -5px rgba(0, 0, 0, 0.2)'
  }
})(Avatar);

var Snackbar = function Snackbar(_ref) {
  var open = _ref.open,
      message = _ref.message,
      onClose = _ref.onClose,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? 'bottom' : _ref$vertical,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? 'center' : _ref$horizontal,
      _ref$autoHideDuration = _ref.autoHideDuration,
      autoHideDuration = _ref$autoHideDuration === void 0 ? 2000 : _ref$autoHideDuration,
      rest = objectWithoutProperties(_ref, ["open", "message", "onClose", "vertical", "horizontal", "autoHideDuration"]);
  return React.createElement(MuiSnackbar, _extends_1({
    anchorOrigin: {
      vertical: vertical,
      horizontal: horizontal
    },
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: onClose,
    ContentProps: {
      'aria-describedby': 'message-id'
    },
    message: jsx("span", {
      id: "message-id"
    }, void 0, message)
  }, rest));
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;
var MoreText = styled(Typography$1)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    marginTop: theme.spacing(1),
    fontWeight: 500
  };
});

var ReadMore = function ReadMore(_ref2) {
  var _ref2$originCharLimit = _ref2.originCharLimit,
      originCharLimit = _ref2$originCharLimit === void 0 ? 150 : _ref2$originCharLimit,
      _ref2$originLineLimit = _ref2.originLineLimit,
      originLineLimit = _ref2$originLineLimit === void 0 ? 5 : _ref2$originLineLimit,
      _ref2$lessButtonText = _ref2.lessButtonText,
      lessButtonText = _ref2$lessButtonText === void 0 ? '접기' : _ref2$lessButtonText,
      _ref2$moreButtonText = _ref2.moreButtonText,
      moreButtonText = _ref2$moreButtonText === void 0 ? '더보기' : _ref2$moreButtonText,
      _ref2$textVariant = _ref2.textVariant,
      textVariant = _ref2$textVariant === void 0 ? 'body1' : _ref2$textVariant,
      _ref2$buttonVariant = _ref2.buttonVariant,
      buttonVariant = _ref2$buttonVariant === void 0 ? 'button' : _ref2$buttonVariant,
      containerProps = _ref2.containerProps,
      children = _ref2.children;

  var _useState = useState(originCharLimit),
      _useState2 = slicedToArray(_useState, 2),
      charLimit = _useState2[0],
      setCharLimit = _useState2[1];

  var _useState3 = useState(originLineLimit),
      _useState4 = slicedToArray(_useState3, 2),
      lineLimit = _useState4[0],
      setLineLimit = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      showFull = _useState6[0],
      setShowFull = _useState6[1];

  var onClickLessButton = useCallback(function () {
    setCharLimit(originCharLimit);
    setLineLimit(originLineLimit);
    setShowFull(false);
  }, [originCharLimit, originLineLimit]);
  var onClickMoreButton = useCallback(function () {
    setShowFull(true);
  }, []);

  var _ref3 = jsx(Typography$1, {
    variant: textVariant
  }, void 0, children, jsx(MoreText, {
    variant: buttonVariant,
    color: "primary",
    onClick: onClickLessButton
  }, void 0, lessButtonText));

  var _ref4 = jsx(MoreText, {
    variant: buttonVariant,
    color: "primary",
    onClick: onClickMoreButton
  }, void 0, moreButtonText);

  var _ref5 = jsx(MoreText, {
    variant: buttonVariant,
    color: "primary",
    onClick: onClickMoreButton
  }, void 0, moreButtonText);

  var _ref6 = jsx(Typography$1, {
    variant: textVariant
  }, void 0, children);

  var getReadMoreContent = useCallback(function () {
    var charLength = children.length;
    var breakedChildren = children.split('\n');
    var breakedLength = breakedChildren.length;

    if (showFull) {
      return _ref3;
    }

    if (breakedLength > lineLimit) {
      return jsx(Typography$1, {
        variant: textVariant
      }, void 0, breakedChildren.slice(0, lineLimit).join('\n'), "...", _ref4);
    }

    if (charLength > charLimit) {
      return jsx(Typography$1, {
        variant: textVariant
      }, void 0, children.substr(0, charLimit), "...", _ref5);
    }

    return _ref6;
  }, [buttonVariant, charLimit, children, lessButtonText, lineLimit, moreButtonText, onClickLessButton, onClickMoreButton, showFull, textVariant]);
  return React.createElement(View, containerProps, getReadMoreContent());
};

var Spinner = styled(CircularProgress)({
  position: 'absolute'
});

var HorizontalSpinner = function HorizontalSpinner(_ref) {
  var spinnerProps = _ref.spinnerProps;
  return jsx(View, {
    alignItems: "center",
    fullWidth: true
  }, void 0, React.createElement(Spinner, _extends_1({
    color: "primary"
  }, spinnerProps)));
};

var WYSIWYGContent = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    '& h1, h2, h3, h4, h5, h6': {
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 'normal'
    },
    '& h1': {
      fontSize: theme.typography.h1.fontSize
    },
    '& h2': {
      fontSize: theme.typography.h2.fontSize
    },
    '& h3': {
      fontSize: theme.typography.h3.fontSize
    },
    '& h4': {
      fontSize: theme.typography.h4.fontSize
    },
    '& h5': {
      fontSize: theme.typography.h5.fontSize
    },
    '& h6': {
      fontSize: theme.typography.h6.fontSize
    },
    '& abbr': {
      borderBottom: '1px dotted',
      cursor: 'help'
    },
    '& cite': {
      fontStyle: 'italic'
    },
    '& hr': {
      background: theme.palette.divider,
      border: 'none',
      display: 'block',
      height: 1,
      marginBottom: '1.4em',
      marginTop: '1.4em'
    },
    '& pre': {
      display: 'block',
      padding: theme.spacing(1),
      margin: "0 0 ".concat(theme.spacing(1), "px"),
      fontSize: 14,
      lineHeight: 1.42857143,
      color: theme.palette.text.primary,
      wordBreak: 'break-all',
      wordWrap: 'break-word',
      backgroundColor: theme.palette.grey[200],
      border: "1px solid ".concat(theme.palette.grey[400]),
      borderRadius: theme.shape.borderRadius,
      '& code': {
        background: 'none',
        fontSize: '1em',
        lineHeight: '1em'
      }
    },
    '& blockquote': {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px"),
      margin: "0 0 ".concat(theme.spacing(2), "px"),
      fontSize: 18,
      borderLeft: "5px solid ".concat(theme.palette.grey[200])
    },
    '& b': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& i': {
      fontStyle: 'italic'
    },
    '& sup': {
      verticalAlign: 'super',
      fontSize: '0.6rem'
    },
    '& sub': {
      verticalAlign: 'sub',
      fontSize: '0.6rem'
    },
    '& ul': {
      listStyle: 'disc'
    },
    '& ol': {
      listStyle: 'decimal'
    },
    '& ul, ol': {
      paddingLeft: theme.spacing(2),
      lineHeight: '1.5rem'
    },
    '& a': {
      color: theme.palette.secondary.main,
      textDecoration: 'none'
    },
    '& table': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      border: "1px solid ".concat(theme.palette.grey[400]),
      width: '100%',
      maxWidth: '100%',
      marginBottom: theme.spacing(2),
      backgroundColor: 'transparent',
      '& tbody': {
        verticalAlign: 'middle',
        '& td': {
          padding: theme.spacing(1),
          border: "1px solid ".concat(theme.palette.grey[400])
        }
      }
    },
    '& img, iframe': defineProperty({
      "float": 'none !important'
    }, theme.breakpoints.down('sm'), {
      width: '100% !important'
    })
  };
});
var Image = styled(function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      round = _ref.round,
      objectFit = _ref.objectFit,
      borderRadius = _ref.borderRadius,
      alt = _ref.alt,
      rest = objectWithoutProperties(_ref, ["width", "height", "round", "objectFit", "borderRadius", "alt"]);
  return React.createElement("img", _extends_1({
    alt: alt
  }, rest));
})(function (_ref2) {
  var theme = _ref2.theme,
      width = _ref2.width,
      height = _ref2.height,
      borderRadius = _ref2.borderRadius,
      round = _ref2.round,
      _ref2$objectFit = _ref2.objectFit,
      objectFit = _ref2$objectFit === void 0 ? 'cover' : _ref2$objectFit;
  var styles = {
    objectFit: objectFit
  };

  if (width) {
    styles.width = width;
  }

  if (height) {
    styles.height = height;
  }

  if (round) {
    styles.borderRadius = theme.shape.borderRadius;
  }

  if (borderRadius) {
    styles.borderRadius = borderRadius;
  }

  return styles;
});

function initSdk(onLoad) {
  var _firstScript$parentNo;

  if (document.getElementById('kakao-jssdk')) return;
  var firstScript = document.getElementsByTagName('script')[0];
  var sdkScript = document.createElement('script');
  sdkScript.id = 'kakao-jssdk';
  sdkScript.src = '//developers.kakao.com/sdk/js/kakao.min.js';
  firstScript === null || firstScript === void 0 ? void 0 : (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(sdkScript, firstScript);

  if (onLoad) {
    sdkScript.onload = onLoad;
  }
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var KakaoLoginButton = function KakaoLoginButton(_ref) {
  var render = _ref.render,
      apiKey = _ref.apiKey,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      loginOptions = _ref.loginOptions,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'account_email,profile' : _ref$scope;
  var initButton = useCallback(function () {
    var sdk = window.Kakao;

    if (sdk) {
      sdk.init(apiKey);
    }
  }, [apiKey]);
  var onSubmit = useCallback(function () {
    var sdk = window.Kakao;

    if (sdk) {
      sdk.Auth.login(_objectSpread$1({
        success: function success(_ref2) {
          var accessToken = _ref2.access_token;
          onSuccess(accessToken);
        },
        fail: onFailure,
        scope: scope,
        persistAccessToken: false
      }, loginOptions));
    }
  }, [onFailure, onSuccess, scope, loginOptions]);
  useEffect(function () {
    initSdk(initButton);
    return function () {
      var _target$parentNode;

      var target = document.getElementById('kakao-jssdk');
      target === null || target === void 0 ? void 0 : (_target$parentNode = target.parentNode) === null || _target$parentNode === void 0 ? void 0 : _target$parentNode.removeChild(target);
    };
  }, [initButton]);
  return render({
    onClick: onSubmit
  });
};

function initMapSdk(apiKey, onLoad) {
  var _firstScript$parentNo;

  if (document.getElementById('kakao-mapsdk')) return;
  var firstScript = document.getElementsByTagName('script')[0];
  var sdkScript = document.createElement('script');
  sdkScript.id = 'kakao-mapsdk';
  sdkScript.src = "//dapi.kakao.com/v2/maps/sdk.js?appKey=".concat(apiKey, "&libraries=services,clusterer,drawing&autoload=false");
  firstScript === null || firstScript === void 0 ? void 0 : (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(sdkScript, firstScript);
  sdkScript.onload = onLoad;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultStyle = {
  width: '100%',
  height: '25vh',
  zIndex: 0
};

function KakaoMap(_ref) {
  var apiKey = _ref.apiKey,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      _ref$mapElemId = _ref.mapElemId,
      mapElemId = _ref$mapElemId === void 0 ? 'kakao-map' : _ref$mapElemId,
      _ref$sdkElemId = _ref.sdkElemId,
      sdkElemId = _ref$sdkElemId === void 0 ? 'kakao-mapsdk' : _ref$sdkElemId,
      style = _ref.style;
  var displayMap = useCallback(function () {
    var mapElement = document.getElementById(mapElemId);
    var _window = window,
        daum = _window.daum;

    if (Object.keys(daum.maps).length > 0) {
      daum.maps.load(function () {
        var position = new daum.maps.LatLng(latitude, longitude);
        var map = new daum.maps.Map(mapElement, {
          level: 3,
          center: position
        });
        var marker = new daum.maps.Marker({
          position: position
        });
        marker.setMap(map);
        return map;
      });
    }
  }, [latitude, longitude, mapElemId]);
  useEffect(function () {
    initMapSdk(apiKey, displayMap);
    var mapElement = document.getElementById(mapElemId);

    if (!mapElement) {
      mapElement = document.createElement('div');
      mapElement.id = mapElemId;
      document.body.appendChild(mapElement);
    }

    return function () {
      var _target$parentNode;

      var target = document.getElementById(sdkElemId);
      target === null || target === void 0 ? void 0 : (_target$parentNode = target.parentNode) === null || _target$parentNode === void 0 ? void 0 : _target$parentNode.removeChild(target);
    };
  }, [apiKey, displayMap, mapElemId, sdkElemId]);
  return jsx("div", {
    id: mapElemId,
    style: _objectSpread$2(_objectSpread$2({}, defaultStyle), style)
  });
}

function initLoginSdk(onLoad) {
  var _firstScript$parentNo;

  if (document.getElementById('naver-jssdk')) return;
  var firstScript = document.getElementsByTagName('script')[0];
  var sdkScript = document.createElement('script');
  sdkScript.id = 'naver-jssdk';
  sdkScript.src = '//static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js';
  firstScript === null || firstScript === void 0 ? void 0 : (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(sdkScript, firstScript);

  if (onLoad) {
    sdkScript.onload = onLoad;
  }
}

var NaverLoginButton = function NaverLoginButton(_ref) {
  var render = _ref.render,
      clientId = _ref.clientId,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure;
  var appendNaverButton = useCallback(function () {
    if (!document.getElementById('naverIdLogin')) {
      var naverId = document.createElement('div');
      naverId.id = 'naverIdLogin';
      naverId.style.position = 'absolute';
      naverId.style.top = '-10000px';
      document.body.appendChild(naverId);
    }
  }, []);
  var initButton = useCallback(function () {
    var sdk = window.naver;

    if (sdk) {
      var naverLogin = new sdk.LoginWithNaverId({
        clientId: clientId,
        callbackUrl: window.location.href,
        isPopup: true,
        loginButton: {
          color: 'green',
          type: 3,
          height: 30
        }
      });
      naverLogin.init();

      if (!window.opener) {
        sdk.successCallback = function (accessToken) {
          return onSuccess(accessToken);
        };

        sdk.failureCallback = onFailure;
      } else {
        naverLogin.getLoginStatus(function (status) {
          if (status) {
            var _accessToken = naverLogin.accessToken.accessToken;
            window.opener.naver.successCallback(_accessToken);
          } else {
            window.opener.failureCallback();
          }

          window.close();
        });
      }
    }
  }, [clientId, onFailure, onSuccess]);
  var onClickButton = useCallback(function () {
    var button = document.getElementById('naverIdLogin');
    var elem = button === null || button === void 0 ? void 0 : button.firstChild;
    elem === null || elem === void 0 ? void 0 : elem.click();
  }, []);
  useEffect(function () {
    appendNaverButton();
    initLoginSdk(initButton);
    return function () {
      var _sdk$parentNode, _btn$parentNode;

      var sdk = document.getElementById('naver-jssdk');
      var btn = document.getElementById('naverIdLogin');
      sdk === null || sdk === void 0 ? void 0 : (_sdk$parentNode = sdk.parentNode) === null || _sdk$parentNode === void 0 ? void 0 : _sdk$parentNode.removeChild(sdk);
      btn === null || btn === void 0 ? void 0 : (_btn$parentNode = btn.parentNode) === null || _btn$parentNode === void 0 ? void 0 : _btn$parentNode.removeChild(btn);
    };
  }, [initButton, appendNaverButton]);
  return render({
    onClick: onClickButton
  });
};

var useStyles$4 = makeStyles(function (theme) {
  return {
    errorText: {
      margin: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px 0")
    }
  };
});

var RequestFieldError = function RequestFieldError(_ref) {
  var _errors$data;

  var errors = _ref.errors,
      fieldName = _ref.fieldName,
      customMessage = _ref.customMessage,
      textProps = _ref.textProps;
  var classes = useStyles$4();

  if (errors === null || errors === void 0 ? void 0 : (_errors$data = errors.data) === null || _errors$data === void 0 ? void 0 : _errors$data[fieldName]) {
    var message = errors.data[fieldName];

    if (customMessage) {
      return React.createElement(React.Fragment, null, React.createElement(Typography, _extends_1({
        color: "error",
        variant: "caption",
        className: classes.errorText
      }, textProps), customMessage));
    }

    return React.createElement(React.Fragment, null, Array.isArray(message) ? message.map(function (err, idx) {
      return React.createElement(Typography, _extends_1({
        key: "".concat(fieldName, "Error").concat(idx),
        color: "error",
        variant: "caption",
        className: classes.errorText
      }, textProps), err);
    }) : React.createElement(Typography, _extends_1({
      color: "error",
      variant: "caption",
      className: classes.errorText
    }, textProps), message));
  }

  return null;
};

var RequestStatusError = function RequestStatusError(_ref) {
  var errors = _ref.errors,
      code = _ref.code,
      message = _ref.message,
      textProps = _ref.textProps;
  var classes = useStyles$4();

  if ((errors === null || errors === void 0 ? void 0 : errors.status) === code) {
    return React.createElement(React.Fragment, null, React.createElement(Typography, _extends_1({
      color: "error",
      variant: "caption",
      className: classes.errorText
    }, textProps), message));
  }

  return null;
};

var TextInput = function TextInput(_ref) {
  var _errors$name;

  var register = _ref.register,
      errors = _ref.errors,
      reqErrors = _ref.reqErrors,
      name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 20 : _ref$maxLength,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      containerProps = _ref.containerProps,
      inputRest = objectWithoutProperties(_ref, ["register", "errors", "reqErrors", "name", "label", "type", "maxLength", "multiple", "containerProps"]);
  return React.createElement(View, containerProps, React.createElement(TextField, _extends_1({
    name: name,
    label: label,
    placeholder: label,
    error: Boolean(errors === null || errors === void 0 ? void 0 : errors[name]),
    helperText: errors === null || errors === void 0 ? void 0 : (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    inputProps: {
      maxLength: maxLength,
      multiple: multiple
    },
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined",
    inputRef: register,
    type: type
  }, inputRest)), reqErrors && jsx(RequestFieldError, {
    errors: reqErrors,
    fieldName: name
  }));
};

React.memo(TextInput);

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultBoxStyle = {
  display: 'inline-block'
};

var CheckboxInput = function CheckboxInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      errors = _ref.errors,
      register = _ref.register,
      labelProps = _ref.labelProps,
      children = _ref.children,
      containerStyle = _ref.containerStyle,
      custom = objectWithoutProperties(_ref, ["name", "label", "errors", "register", "labelProps", "children", "containerStyle"]);
  var formError = errors[name];
  return jsx("div", {
    style: _objectSpread$3(_objectSpread$3({}, defaultBoxStyle), containerStyle)
  }, void 0, React.createElement(FormControlLabel, _extends_1({
    name: name,
    control: React.createElement(Checkbox, _extends_1({}, custom, {
      inputRef: register,
      color: "primary"
    })),
    label: label
  }, labelProps)), Boolean(formError) && jsx(MuiTypography, {
    variant: "caption",
    color: "error",
    style: {
      marginLeft: 6
    }
  }, void 0, formError.message), children);
};

var RadioGroup = function RadioGroup(_ref) {
  var name = _ref.name,
      errors = _ref.errors,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["name", "errors", "children"]);
  var formError = errors === null || errors === void 0 ? void 0 : errors.name;
  var hasError = Boolean(formError);
  return React.createElement(React.Fragment, null, React.createElement(MuiRadioGroup, _extends_1({
    name: name
  }, rest), children), hasError && jsx(Typography, {
    variant: "caption",
    color: "error",
    style: {
      marginLeft: 6
    }
  }, void 0, formError.message));
};

var IconBase = function IconBase(props) {
  var IconType = props.IconType,
      white = props.white,
      classes = props.classes,
      rest = objectWithoutProperties(props, ["IconType", "white", "classes"]);
  var iconClasses = clsx(defineProperty({}, classes.white, white));
  return React.createElement(IconType, _extends_1({
    className: iconClasses
  }, rest));
};

var Icon = withStyles$1({
  white: {
    color: '#fff'
  }
})(IconBase);

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$5 = makeStyles(function (theme) {
  return {
    icon: {
      opacity: 0.8,
      zIndex: 1500,
      cursor: 'pointer',
      position: 'absolute',
      touchAction: 'manipulation',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    }
  };
});

var DefaultArrow = function DefaultArrow(_ref) {
  var _ref$left = _ref.left,
      left = _ref$left === void 0 ? false : _ref$left,
      onClick = _ref.onClick,
      style = _ref.style;
  var classes = useStyles$5();
  var ArrowIcon = left ? ChevronLeftRounded : ChevronRightRounded;
  var location = left ? {
    left: -20
  } : {
    right: -20
  };
  return jsx(Icon, {
    onClick: onClick,
    IconType: ArrowIcon,
    style: _objectSpread$4(_objectSpread$4({}, style), location),
    className: classes.icon
  });
};

var StyledRow = styled(Box$1)(function (_ref) {
  var theme = _ref.theme,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing;

  if (spacing) {
    return {
      '& > *': {
        marginRight: theme.spacing(spacing)
      }
    };
  }

  return {};
});
var useStyles$6 = makeStyles({
  spacing: {
    '& > *:last-child': {
      marginRight: 0
    }
  },
  container: {
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
    transition: 'transform .4s ease-in',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  }
});
var PER_SCROLL = 300;

function HorizontalList(_ref2) {
  var _clsx;

  var _ref2$useArrow = _ref2.useArrow,
      useArrow = _ref2$useArrow === void 0 ? true : _ref2$useArrow,
      _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 0 : _ref2$spacing,
      children = _ref2.children,
      props = objectWithoutProperties(_ref2, ["useArrow", "spacing", "children"]);
  var classes = useStyles$6();
  var containerRef = useRef(null);

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      leftPos = _useState2[0],
      setLeftPos = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      isRightEnd = _useState4[0],
      setIsRightEnd = _useState4[1];

  var setRightButtonStatus = useCallback(function () {
    if (containerRef.current) {
      var row = containerRef.current;
      var sl = row.scrollLeft;
      var sw = row.scrollWidth;
      var currentScroll = sl + row.clientWidth;
      setIsRightEnd(currentScroll + PER_SCROLL >= sw);
    }
  }, [containerRef]);
  var onClickLeft = useCallback(function () {
    if (containerRef.current) {
      var row = containerRef.current;
      var scrollAmount = 0;
      var sl = row.scrollLeft;

      if (sl > 0) {
        setIsRightEnd(false);
        var slideTimer = setInterval(function () {
          setLeftPos(row.scrollLeft);
          row.scrollLeft -= 10;
          scrollAmount += 10;

          if (scrollAmount >= PER_SCROLL) {
            window.clearInterval(slideTimer);
          }
        }, 10);
      }
    }
  }, [containerRef]);
  var onClickRight = useCallback(function () {
    if (containerRef.current) {
      var row = containerRef.current;
      var scrollAmount = 0;
      var sl = row.scrollLeft;
      var sw = row.scrollWidth;
      var currentScroll = sl + row.clientWidth;
      setRightButtonStatus();

      if (currentScroll < sw) {
        var slideTimer = setInterval(function () {
          setLeftPos(row.scrollLeft);
          row.scrollLeft += 10;
          scrollAmount += 10;

          if (scrollAmount >= PER_SCROLL) {
            window.clearInterval(slideTimer);
          }
        }, 10);
      }
    }
  }, [containerRef, setRightButtonStatus]);
  useWindowSize(setRightButtonStatus);
  var rowClassName = clsx((_clsx = {}, defineProperty(_clsx, classes.container, true), defineProperty(_clsx, classes.spacing, spacing > 0), _clsx));
  return React.createElement(FlexRow, _extends_1({
    position: "relative"
  }, props), useArrow && leftPos > 0 && jsx(DefaultArrow, {
    left: true,
    onClick: onClickLeft
  }), React.createElement(StyledRow, _extends_1({
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    className: rowClassName,
    spacing: spacing
  }, {
    ref: containerRef
  }), children), useArrow && !isRightEnd && jsx(DefaultArrow, {
    onClick: onClickRight
  }));
}

var StyledView = styled(View)(function (_ref) {
  var theme = _ref.theme,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing;

  if (spacing) {
    return {
      '& > *': {
        marginBottom: theme.spacing(spacing)
      }
    };
  }

  return {};
});
var useStyles$7 = makeStyles({
  spacing: {
    '& > *:last-child': {
      marginBottom: 0
    }
  }
});

function VerticalList(_ref2) {
  var spacing = _ref2.spacing,
      className = _ref2.className,
      children = _ref2.children,
      props = objectWithoutProperties(_ref2, ["spacing", "className", "children"]);
  var classes = useStyles$7();
  var viewClassName = clsx(spacing && classes.spacing, Boolean(className) && className);
  return React.createElement(StyledView, _extends_1({
    className: viewClassName,
    spacing: spacing
  }, props), children);
}

function FlatList(_ref) {
  var data = _ref.data,
      renderItem = _ref.renderItem,
      ItemSeparatorComponent = _ref.ItemSeparatorComponent,
      ListEmptyComponent = _ref.ListEmptyComponent,
      keyExtractor = _ref.keyExtractor,
      _ref$listType = _ref.listType,
      listType = _ref$listType === void 0 ? 'vertical' : _ref$listType,
      contentContainerProps = _ref.contentContainerProps;
  var length = useMemo(function () {
    return (data === null || data === void 0 ? void 0 : data.length) || 0;
  }, [data]);
  var Container = listType === 'horizontal' ? HorizontalList : VerticalList;

  if (!data) {
    return null;
  }

  if (!length && ListEmptyComponent) {
    return jsx(ListEmptyComponent, {});
  }

  var _ref2 = jsx(ItemSeparatorComponent, {});

  return React.createElement(Container, contentContainerProps, React.createElement(React.Fragment, null, data.map(function (item, index) {
    return jsx(Fragment, {}, keyExtractor(item, index), renderItem(item, index), ItemSeparatorComponent && index !== length - 1 && _ref2);
  })));
}

var Maybe = function Maybe(_ref) {
  var test = _ref.test,
      children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'rect' : _ref$variant,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'pulse' : _ref$animation,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'span' : _ref$component,
      width = _ref.width,
      height = _ref.height,
      classes = _ref.classes,
      rest = objectWithoutProperties(_ref, ["test", "children", "variant", "animation", "component", "width", "height", "classes"]);
  return test ? React.createElement(React.Fragment, null, children) : React.createElement(Box, rest, jsx(Skeleton, {
    animation: animation,
    component: component,
    classes: classes,
    height: height,
    variant: variant,
    width: width
  }));
};

export { AbsoluteCenterSpinner, Card, CardAvatar, CheckboxInput, Container, Divider, FlatList, FlexRow, HorizontalList, HorizontalSpinner, Icon, Image, KakaoLoginButton, KakaoMap, Maybe, NaverLoginButton, RadioGroup, ReadMore, RequestFieldError, RequestStatusError, Snackbar, TextInput, Typography, View, WYSIWYGContent };
